import axios from "axios";
import { urlConstants } from "../components/constants/globalConstants";

export const axiosAPI = (env: string) => {
  
  return axios.create({
    baseURL: env === 'seedcore' ? urlConstants.CORE_ENV_PROD_URL : urlConstants.NODE_ENV_PROD_URL,
  });
};